import Page from './index';
import { authRoles } from 'app/auth';
export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	auth: authRoles.superAdmin,
	routes: [
		{
			path: '/admin-activity-log',
			exact: true,
			component: Page.Layout
		},
	]
};